import React from 'react';
import styled from 'styled-components';
import Icon from '../atom/Icon';

export const DaumPostcode = ({ closeDaumPostcode }) => {
  return (
    <AddressBox id="addressBox" style={{ width: '100%' }}>
      <Icon
        size={20}
        iconName="close"
        className="material-icons"
        style={{
          position: 'absolute',
          cursor: 'pointer',
          zIndex: 1,
          left: '-3px',
          top: '-3px',
          backgroundColor: 'black',
          color: 'white',
        }}
        onClick={closeDaumPostcode}
      />
    </AddressBox>
  );
};

const AddressBox = styled.div`
  position: fixed;
  display: none;
  overflow: hidden;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
`;
